import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'practica-upt-logo',
  templateUrl: './upt-logo.component.html',
  styleUrls: ['./upt-logo.component.scss']
})
export class UptLogoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
